// React
import React, { useState, useEffect } from 'react';

// Component
import {
  CRUDLayout,
  Input,
  InputSearch,
  Tr,
  CreateButton,
  ActionButton,
  DataStatus,
  DeleteModal,
  Switch,
  Th,
  Td,
  UpdateButton,
  DeleteButton,
  Alert,
  ThFixed,
  Pagination,
  THead,
  TBody,
  TdFixed,
  TextArea,
} from '../../../components';
import { PageNumber } from '../../../utilities';
import { Col, ModalBody, ModalFooter, Modal } from 'react-bootstrap';

// Form
import { Formik } from 'formik';
import * as Yup from 'yup';

// API
import { BarangJadiSeriApi } from '../../../api';
import { useIsGuest } from 'hooks';

const BarangJadiSeri = ({ setNavbarTitle }) => {
  const title = 'Barang Jadi Seri';
  const isGuest = useIsGuest();
  // STATE LOADING
  const [isLoading, setIsLoading] = useState(false);

  // STATE SEARCHING
  const [searchKey, setSearchKey] = useState('');

  // MODALS SHOW STATE
  const [modal, setModal] = useState({
    show: false,
    tipe: '',
    data: {},
  });

  // STATE DATA SATUAN
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [dataLength, setDataLength] = useState(10);
  const [totalPage, setTotalPage] = useState(1);
  const [dataCount, setDataCount] = useState(0);

  // ALERT STATE
  const [showAlert, setShowAlert] = useState(false);
  // KONFIGURASI ALERT
  const [alertConfig, setAlertConfig] = useState({
    variant: 'primary',
    text: '',
  });

  // FUNCTION GET DATA DARI SERVER
  const getData = () => {
    setIsLoading(true);

    BarangJadiSeriApi.page({
      page,
      per_page: dataLength,
      q: searchKey,
    })
      .then((res) => {
        setData(res.data.data);
        setTotalPage(res.data.total_page);
        setDataCount(res.data.data_count);
      })
      .finally(() => setIsLoading(false));
  };

  // FUNCTION SWITCH HIDDEN DATA
  // TODO: CHECK SWITCH SHOW HIDDEN BUG API
  const changeDataStatus = (status, id_barang_jadi_seri) => {
    setIsLoading(true);
    setShowAlert(false);

    const onLoadedSuccess = () => {
      setAlertConfig({
        variant: 'primary',
        text: 'Ubah status data berhasil',
      });
      setShowAlert(true);
    };

    const onLoadedFailed = () => {
      setAlertConfig({
        variant: 'danger',
        text: 'Ubah status data gagal',
      });
      setShowAlert(true);
    };

    status === true
      ? BarangJadiSeriApi.show({ id_barang_jadi_seri })
          .then(() => onLoadedSuccess())
          .catch(() => onLoadedFailed())
          .finally(() => getData())
      : BarangJadiSeriApi.hide({ id_barang_jadi_seri })
          .then(() => onLoadedSuccess())
          .catch(() => onLoadedFailed())
          .finally(() => getData());
  };

  // ON COMPONENT MOUNT
  useEffect(() => {
    setNavbarTitle(title); // SET JUDUL NAVBAR
    // setShowAlert(false)
    getData(); // GET DATA DARI SERVER

    return () => {
      setIsLoading(false);
    };
  }, [setNavbarTitle, page, dataLength, searchKey]);

  // MODAL TAMBAH COMPONENT
  const DataModal = () => {
    // FORMIK INITIAL VALUES
    const formInitialValues = {
      nama_barang_jadi_seri:
        modal?.tipe === 'ubah' ? modal?.data?.nama_barang_jadi_seri : '',
      keterangan: modal?.tipe === 'ubah' ? modal?.data?.keterangan : '',
    };

    // FORMIK VALIDATION SCHEMA DENGAN YUP VALIDATION
    const formValidationSchema = Yup.object().shape({
      nama_barang_jadi_seri: Yup.string()
        .test(
          'check_nama',
          'Nama Barang Jadi Seri telah digunakan',
          (nama_barang_jadi_seri) =>
            modal?.data?.nama_barang_jadi_seri === nama_barang_jadi_seri
              ? true
              : BarangJadiSeriApi.single({ nama_barang_jadi_seri })
                  .then(() => false)
                  .catch(() => true)
        )
        .required('Nama Barang Jadi Seri wajib diisi'),
    });

    // KIRIM DATA BARU KE SERVER
    const formSubmitHandler = (values) => {
      if (modal?.tipe === 'tambah') {
        BarangJadiSeriApi.create(values)
          .then(() => {
            // SUCCESS ALERT
            setAlertConfig({
              variant: 'primary',
              text: 'Tambah data berhasil!',
            });
          })
          .catch(() => {
            // ERROR ALERT
            setAlertConfig({
              variant: 'danger',
              text: `Tambah data gagal!`,
            });
          })
          .finally(() => {
            // CLOSE MODAL
            setModal({
              ...modal,
              show: false,
              data: {},
            });
            // TAMPILKAN ALERT
            setShowAlert(true);
            // FETCH DATA DARI SERVER
            getData();
          });
      } else {
        values.id_barang_jadi_seri = modal?.data?.id_barang_jadi_seri;

        BarangJadiSeriApi.update(values)
          .then(() => {
            // SUCCESS ALERT
            setAlertConfig({
              variant: 'primary',
              text: 'Ubah data berhasil!',
            });
          })
          .catch(() => {
            // ERROR ALERT
            setAlertConfig({
              variant: 'danger',
              text: `Ubah data gagal!`,
            });
          })
          .finally(() => {
            // CLOSE MODAL
            setModal({
              ...modal,
              show: false,
              data: {},
            });
            // TAMPILKAN ALERT
            setShowAlert(true);
            // FETCH DATA DARI SERVER
            getData();
          });
      }
    };

    return (
      <Modal
        show={modal?.show && modal?.tipe !== 'hapus'}
        onHide={() =>
          setModal({
            ...modal,
            show: false,
            data: {},
          })
        }
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h6 className="mb-0 text-capitalize">
              {modal?.tipe} Data {title}
            </h6>
          </Modal.Title>
        </Modal.Header>

        <Formik
          initialValues={formInitialValues}
          validationSchema={formValidationSchema}
          onSubmit={formSubmitHandler}
        >
          {({
            values,
            errors,
            touched,
            isSubmitting,
            handleChange,
            handleSubmit,
          }) => (
            <form onSubmit={handleSubmit}>
              <ModalBody>
                <Input
                  label="Nama Barang Jadi Seri"
                  placeholder="Nama Barang Jadi Seri"
                  type="text"
                  name="nama_barang_jadi_seri"
                  value={values.nama_barang_jadi_seri}
                  onChange={handleChange}
                  error={
                    errors.nama_barang_jadi_seri &&
                    touched.nama_barang_jadi_seri &&
                    true
                  }
                  errorText={errors.nama_barang_jadi_seri}
                />

                <TextArea
                  label="Keterangan"
                  placeholder="Keterangan"
                  name="keterangan"
                  value={values.keterangan}
                  onChange={handleChange}
                  error={errors.keterangan && touched.keterangan && true}
                  errorText={errors.keterangan}
                  rows={3}
                />
              </ModalBody>

              <ModalFooter>
                <ActionButton
                  type="submit"
                  variant="primary"
                  text="Simpan"
                  loading={isSubmitting}
                />
              </ModalFooter>
            </form>
          )}
        </Formik>
      </Modal>
    );
  };

  // MODAL HAPUS COMPONENT
  const HapusModal = () => {
    // MENANGANI DELETE BUTTON LOADING
    const [btnLoading, setBtnLoading] = useState(false);

    // DELETE DATA DARI SERVER
    const deleteDataHandler = () => {
      setBtnLoading(true);

      BarangJadiSeriApi.delete({
        id_barang_jadi_seri: modal?.data?.id_barang_jadi_seri,
      })
        .then(() => {
          // KONFIGURASI ALERT
          setAlertConfig({
            variant: 'primary',
            text: 'Hapus data berhasil!',
          });
        })
        .catch(() => {
          // KONFIGURASI ALERT
          setAlertConfig({
            variant: 'danger',
            text: `Hapus data gagal!`,
          });
        })
        .finally(() => {
          // CLOSE MODAL
          setModal({
            ...modal,
            show: false,
            data: {},
          });
          // TAMPIL ALERT
          setShowAlert(true);
          // FETCH DATA DARI SERVER
          getData();
        });
    };

    return (
      <DeleteModal
        show={modal?.show && modal?.tipe === 'hapus'}
        onHide={() =>
          setModal({
            ...modal,
            show: false,
            data: {},
          })
        }
        loading={btnLoading}
        onConfirm={deleteDataHandler}
        title={title}
      >
        <div>Nama Barang Jadi Seri : {modal?.data?.nama_barang_jadi_seri}</div>
      </DeleteModal>
    );
  };

  // TABLE COMPONENT
  const Table = () => {
    return (
      <>
        <CRUDLayout.Table>
          <THead>
            <Tr className="text-center">
              <ThFixed>No</ThFixed>
              {!isGuest && <ThFixed>Aksi</ThFixed>}
              <Th>Nama Barang Jadi Seri</Th>
              <Th>Keterangan</Th>
            </Tr>
          </THead>
          <TBody>
            {data.map((val, index) => {
              return (
                <Tr key={val.id_kayu}>
                  <TdFixed>{PageNumber(page, dataLength, index)}</TdFixed>
                  {!isGuest && (
                    <TdFixed>
                      <div className="d-flex justify-content-center">
                        <UpdateButton
                          onClick={() =>
                            setModal({
                              show: true,
                              tipe: 'ubah',
                              data: val,
                            })
                          }
                        />
                        <DeleteButton
                          onClick={() =>
                            setModal({
                              show: true,
                              tipe: 'hapus',
                              data: val,
                            })
                          }
                        />
                        <Switch
                          id={val.id_barang_jadi_seri}
                          checked={val.is_hidden ? false : true}
                          onChange={() =>
                            changeDataStatus(
                              val.is_hidden,
                              val.id_barang_jadi_seri
                            )
                          }
                        />
                      </div>
                    </TdFixed>
                  )}
                  <Td>{val.nama_barang_jadi_seri}</Td>
                  <Td>{val.keterangan}</Td>
                </Tr>
              );
            })}
          </TBody>
        </CRUDLayout.Table>
        <Pagination
          dataLength={dataLength}
          dataNumber={page * dataLength - dataLength + 1}
          dataPage={page * dataLength}
          dataCount={dataCount}
          onDataLengthChange={(e) => {
            setPage(1);
            setDataLength(e.target.value);
          }}
          currentPage={page}
          totalPage={totalPage}
          onPaginationChange={({ selected }) => setPage(selected + 1)}
        />
      </>
    );
  };

  return (
    <CRUDLayout>
      <CRUDLayout.Head>
        <CRUDLayout.HeadSearchSection>
          <div className="row">
            <Col md="8">
              <InputSearch
                // onChange={(e) => {
                //   setSearchKey(e.target.value)
                //   setPage(1)
                // }}
                // onSubmit={(e) => e.preventDefault()}
                onChange={(e) => {
                  const key = e.target.value;
                  setSearchKey(e.target.value);
                  key ? setShowAlert(true) : setShowAlert(false);
                  setAlertConfig({
                    variant: 'primary',
                    text: 'Hasil dari pencarian: ' + key,
                  });
                }}
              />
            </Col>
          </div>
        </CRUDLayout.HeadSearchSection>

        {/* Button Section */}
        <CRUDLayout.HeadButtonSection>
          {/* Button Tambah */}
          <CreateButton
            onClick={() =>
              setModal({
                show: true,
                tipe: 'tambah',
                data: {},
              })
            }
          />
        </CRUDLayout.HeadButtonSection>
      </CRUDLayout.Head>

      {/* Alert */}
      <Alert
        show={showAlert}
        showCloseButton={true}
        variant={alertConfig.variant}
        text={alertConfig.text}
        onClose={() => setShowAlert(false)}
      />

      {isLoading ? (
        <DataStatus loading={isLoading} text="Memuat Data" />
      ) : !Array.isArray(data) ? (
        <DataStatus text="Tidak dapat memuat data" />
      ) : data.length > 0 ? (
        <Table />
      ) : (
        <DataStatus text="Tidak ada data" />
      )}

      {/* MODAL */}
      <DataModal />
      <HapusModal />
    </CRUDLayout>
  );
};

export default BarangJadiSeri;
